import { queryOptions, useQueries, useQuery } from '@tanstack/react-query';
import { getKgInsight } from '@terminal/services/insights/kg-insights-service';

export const QUERY_KEY_KG_INSIGHT = 'QUERY_KEY_KG_INSIGHT';

export const createKgInsightQueryOptions = (insightId: string) =>
  queryOptions({
    queryKey: [QUERY_KEY_KG_INSIGHT, insightId],
    queryFn: () => getKgInsight(insightId),
    enabled: !!insightId,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 1, // 1 hour
  });

export const useKgInsight = (insightId: string) =>
  useQuery(createKgInsightQueryOptions(insightId));

export const useKgInsightsByIdResult = (insightIds: string[]) =>
  useQueries({
    queries: insightIds.map(createKgInsightQueryOptions),
    combine: results => ({
      data: new Map(
        results.flatMap(result =>
          result.data ? [[result.data.id, result.data] as const] : []
        )
      ),
      isLoading: results.some(result => result.isLoading),
    }),
  });

export const useKgInsightsById = (insightIds: string[]) =>
  useKgInsightsByIdResult(insightIds).data;
